import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import numberFormat from 'utils/number/format';
import currencyFormat from 'utils/currency/numberToPrice';
import { deferExecutor } from 'app/DeferredOnLocation';
import { saveProfile } from 'data/user';
import { selectIsLoading, selectProfile } from 'data/user/selectors';
import classNames from "classnames";
import { useState } from 'react';
import PageTitle from '../components/PageTitle';
import PlanCard from './PlanCard';
import css from './style.scss';
import { useEffect } from 'react';
import { isLegacyAccountPlan, selectPlanDetails, selectUserId } from '../../../data/user/selectors';
import { planOptions, sortedPlanOptions } from './planUtils';
import { updateSelectedChooseTierTooltip, updateSelectedManagePlan } from '../../../data/user';
import LeaveMessagePopup from '../modals/LeaveMessage';
import propstreamAccountLogo from "assets/images/account-page/propstreamlogo-account.svg";
import { isPropStream } from "utils/brand";

const ChooseTier = (props) => {
    const [annualPlan, setAnnualPlan] = useState(false);
    const [annualPlans, setAnnualPlans] = useState([]);
    const [monthlyPlans, setMonthlyPlans] = useState([]);
    const [selectedPlanOption, setSelectedPlanOption] = React.useState(planOptions[0]);
    const isLegacyAccount = useSelector(isLegacyAccountPlan)
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();

    useEffect(() => {
        if (planDetails?.availableUserPlans?.length > 0 && (annualPlans.length === 0 || monthlyPlans.length === 0)) {
            let sortedPlans = [];
            const updatedPlans = planDetails?.availableUserPlans.map((plan) => ({
                ...plan,
                hidePlan: plan.name.includes("Essentials") && plan.savedPropertyLimit !== selectedPlanOption,
                planIncludes: plan.description
                    .split(',')
                    .map((item) => ({ text: item.trim() })),
            }));
            if (updatedPlans && updatedPlans.length > 0) {
                sortedPlans = sortedPlanOptions(updatedPlans);
            }
            const annual =  sortedPlans.filter((plan) => plan.planFrequency === 'Annual');
            const monthly = sortedPlans.filter((plan) => plan.planFrequency === 'Monthly');
            let annualWithDiscounts = [];
            if (annual && annual.length > 0) {
                annualWithDiscounts = annual.map((plan => ({
                    ...plan,
                    extraValue: plan.name.includes("Essentials") ? 38 : plan.name.includes("Pro") ? 142 : plan.name.includes("Elite") ? 59 : 0,
                    // initialAmount: plan.planFrequency === 'Annual' ? 
                    //     (plan.name.includes("Essentials") ? 99 : plan.name.includes("Pro") ? 199 : 
                    //     plan.name.includes("Elite") ? 699 : null) : plan.initialAmount,
                    // planAmount: plan.planFrequency === 'Annual' ? 
                    //     (plan.name.includes("Essentials") ? 81 : plan.name.includes("Pro") ? 165 : 
                    //     plan.name.includes("Elite") ? 583 : null) : plan.planAmount,
                    planDisMonthlyAmount: plan.planFrequency === 'Annual' ? 
                        (plan.planAmount/12) : plan.planAmount,
                })));
            }
            setAnnualPlans(annualWithDiscounts);
            setMonthlyPlans(monthly);
            setAnnualPlan(planDetails?.isAnnualPlanSelected);
        }
    }, [planDetails])

    const selectPlan = (plan) => {
        dispatch(updateSelectedManagePlan(plan));
        dispatch(updateSelectedChooseTierTooltip(""));
        props.history.push(`/accountnew/plan/review`);
    }

    useEffect(() => {
        handlePlanOptions(selectedPlanOption);
    }, [selectedPlanOption, annualPlan])

    const handlePlanOptions = (value) => {
        let plans = [];
        if (annualPlan) {
            plans = annualPlans.map((plan) => ({
                ...plan,
                hidePlan: plan.name.includes("Essentials") && plan.savedPropertyLimit !== Number(value) ? true : false,
            }));
            setAnnualPlans(plans);
        } else {
            plans = monthlyPlans.map((plan) => ({
                ...plan,
                hidePlan: plan.name.includes("Essentials") && plan.savedPropertyLimit !== Number(value) ? true : false,
            }));
            setMonthlyPlans(plans);
        }
    }

    const goToAccount = () => {
        props.leaveMessagePopup({
            title: "Are you sure want to leave?",
            message: "Please press yes to leave the page, no to stay on the page",
            cancelLable: 'No',
            yesLable: 'Yes',
            yesRedirect: () => {
            props.history.push(`/accountnew/landing`);
            },
        });
    }

    const getPlanName = () => {
        if (isLegacyAccount) return "Legacy";
        if (planDetails?.accountEnrolledPlans && planDetails?.accountEnrolledPlans.length > 0) {
          const selectedPlan = planDetails.availableUserPlans.find(plan => plan.id === planDetails?.accountEnrolledPlans[0]?.planId);
          if (selectedPlan && selectedPlan?.name) return selectedPlan.name.split(' ')[0];
          return "";
        }
        return "";
    }
    
    return (
        <React.Fragment>
            {isPropStream() && (
                <div className={css.planLogoWrapper}>
                    <img
                        src={propstreamAccountLogo}
                        alt="PropStream Logo"
                        className={css.logo}
                    />
                </div>
            )}
            <PageTitle
                title={'Choose A Plan Tier'}
                subTitle={'Prices shown are for base plans only and do not include add-on services or extra one-time payments'}
            />

            <div className={css.container}> 
                <div className={css.planContainer}>
                    <div className={css.currentPlan}>Current Plan</div>
                    <div className={css.planName}>{getPlanName()} 
                        {!isLegacyAccount && <>
                            ({planDetails?.accountEnrolledPlans?.length > 0 && 
                                numberFormat(planDetails?.accountEnrolledPlans[0]?.quantity)} Saves & Exports)
                        </>}
                        </div>
                    <div className={css.planAmount}>{planDetails?.accountEnrolledPlans?.length > 0 && currencyFormat(planDetails?.accountEnrolledPlans[0]?.amount)}/{planDetails?.accountEnrolledPlans[0]?.currentAnnual ? 'yr' : 'mo'}</div>
                </div>
            </div>

            <div className={css.container}>
                <div className={css.tabContainer}>
                    <button onClick={() => setAnnualPlan(true)} className={annualPlan ? css.activeTab : css.tab}>Annual</button>
                    <button onClick={() => setAnnualPlan(false)} className={annualPlan ? css.tab : css.activeTab}>Monthly</button>
                </div>
            </div>

            {
                annualPlan ?
                    <div className={css.priceContainer}>
                        {
                            annualPlans && annualPlans.length > 0 && annualPlans.map((plan) =>
                                !plan.hidePlan && <PlanCard
                                    key={plan.planName}
                                    planName={plan.name}
                                    planDescription={plan.description}
                                    currentPrice={plan.planAmount}
                                    discountPrice={plan.discountPrice}
                                    planIncludes={plan.planIncludes}
                                    extraValue={plan.extraValue}
                                    initialAmount={plan.planMonthlyAmount}
                                    planDisMonthlyAmount={plan?.planDisMonthlyAmount}
                                    annualPlan={true}
                                    selectedPlanOption={selectedPlanOption}
                                    planDisabled={planDetails?.accountEnrolledPlans[0]?.planId === plan.id}
                                    setSelectedPlanOption={setSelectedPlanOption}
                                    selectPlan={() => selectPlan(plan)}
                                />
                            )
                        }
                    </div>
                    :
                    <div className={css.priceContainer}>
                        {
                            monthlyPlans && monthlyPlans.length > 0 && monthlyPlans.map((plan) =>
                                !plan.hidePlan && <PlanCard
                                    key={plan.name}
                                    planName={plan.name}
                                    planDescription={plan.description}
                                    currentPrice={plan.planAmount}
                                    planIncludes={plan.planIncludes}
                                    initialAmount={plan.initialAmount}
                                    selectedPlanOption={selectedPlanOption}
                                    setSelectedPlanOption={setSelectedPlanOption}
                                    planDisabled={planDetails?.accountEnrolledPlans[0]?.planId === plan.id}
                                    selectPlan={() => selectPlan(plan)}
                                />
                            )
                        }
                    </div>
            }

            <div className={css.clsInnerFooter}>
                    <button className={classNames(css.clsBackBtn)} onClick={() => goToAccount()}>Return to Account</button>
                  </div> 
        </React.Fragment>
    );
}

export default withRouter(connect(state => ({
    profile: selectProfile(state).toJS(),
    isLoading: selectIsLoading(state)
}), {
    saveProfile,
    leaveMessagePopup: LeaveMessagePopup.open
})(deferExecutor(ChooseTier)));
